import { Box, styled } from "prism-react";

const StyledDevtoolWrapper = styled(Box, {
  padding: "$4",
  position: "relative",
  height: "100%",
  overflow: "hidden",
  background: "var(--vscode-tab-activeBackground, $neutral-bg-subtle)",

  // While any devtool button is expanded, clicking outside should collapse the button
  // So the iframe should have disalbed pointer events while the button is expanded
  "&:has(.expandable-devtool-button[data-open='true']) iframe": {
    pointerEvents: "none",
  },

  variants: {
    variant: {
      terminal: {
        paddingRight: 0,
      },
      file: {
        padding: 0,
      },
      log: {
        paddingRight: 0,
      },
      preview: {
        padding: 0,
      },
      setup: {
        color: "$neutral-fg-base",
      },
      "assistant-chat": {
        color: "$neutral-fg-base",
      },
    },
  },
});

export interface DevtoolWrapperProps
  extends React.ComponentProps<typeof StyledDevtoolWrapper> {
  children: React.ReactNode;
  variant: "log" | "preview" | "terminal" | "setup" | "file" | "assistant-chat";
}

export const DevtoolWrapper: React.FC<DevtoolWrapperProps> = ({
  children,
  variant,
  ...props
}) => {
  return (
    <StyledDevtoolWrapper variant={variant} {...props}>
      {children}
    </StyledDevtoolWrapper>
  );
};
